module.exports = __webpack_public_path__ + "assets/img/f-c-1.991e7348.png";